import { IQuyetDinhHocVuActionTypes } from "../../action-types/xet-hoc-vu/IQuyetDinhHocVuActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IQuyetDinhHocVuReducer } from "../../reducer-model/xet-hoc-vu/IQuyetDinhHocVuReducer";

const iniState: IQuyetDinhHocVuReducer = {
    status: eReducerStatusBase.is_not_initialization,
    quyetDinhs: [],
    sinhVienStatus: eReducerStatusBase.is_not_initialization,
    sinhViens: [],
};

export const quyetDinhHocVuReducer = (state: IQuyetDinhHocVuReducer = iniState, action: IQuyetDinhHocVuActionTypes): IQuyetDinhHocVuReducer => {
    switch (action.type) {
        case "QUYET_DINH_HOC_VU_LOAD_BY_DOT_START":
            return { ...state, status: eReducerStatusBase.is_loading };
        case "QUYET_DINH_HOC_VU_LOAD_SUCCESS":
            return { ...state, status: eReducerStatusBase.is_completed, quyetDinhs: action.payload };
        case "QUYET_DINH_HOC_VU_LOAD_ERROR":
            return { ...state, status: eReducerStatusBase.is_completed };

        case "QUYET_DINH_HOC_VU_SHOW_EDIT_MODAL":
            return { ...state, isShowEditModal: true, quyetDinhEdit: action.payload };
        case "QUYET_DINH_HOC_VU_CLOSE_EDIT_MODAL":
            return { ...state, isShowEditModal: false, quyetDinhEdit: undefined };

        case "QUYET_DINH_HOC_VU_SAVE_START":
            return { ...state, status: eReducerStatusBase.is_saving };
        case "QUYET_DINH_HOC_VU_SAVE_SUCCESS":
            return { ...state, status: eReducerStatusBase.is_need_reload, isShowEditModal: false, quyetDinhEdit: undefined };
        case "QUYET_DINH_HOC_VU_SAVE_ERROR":
            return { ...state, status: eReducerStatusBase.is_completed };

        case "QUYET_DINH_HOC_VU_DELETE_START":
            return { ...state, status: eReducerStatusBase.is_deleting };
        case "QUYET_DINH_HOC_VU_DELETE_SUCCESS":
            return { ...state, status: eReducerStatusBase.is_need_reload };
        case "QUYET_DINH_HOC_VU_DELETE_ERROR":
            return { ...state, status: eReducerStatusBase.is_completed };

        case "QUYET_DINH_HOC_VU_SHOW_SINH_VIEN_MODAL":
            return { ...state, isShowSinhVienModal: true, quyetDinhSelected: action.payload };
        case "QUYET_DINH_HOC_VU_CLOSE_SINH_VIEN_MODAL":
            return { ...state, isShowSinhVienModal: false, quyetDinhSelected: undefined, sinhViens: [], status: eReducerStatusBase.is_need_reload };

        case "QUYET_DINH_HOC_VU_LOAD_SINH_VIEN_START":
            return { ...state, sinhVienStatus: eReducerStatusBase.is_loading };
        case "QUYET_DINH_HOC_VU_LOAD_SINH_VIEN_SUCCESS":
            return { ...state, sinhVienStatus: eReducerStatusBase.is_completed, sinhViens: action.payload };
        case "QUYET_DINH_HOC_VU_LOAD_SINH_VIEN_ERROR":
            return { ...state, sinhVienStatus: eReducerStatusBase.is_completed };

        case "QUYET_DINH_HOC_VU_DONG_BO_KET_QUA_START":
        case "QUYET_DINH_HOC_VU_ADD_SINH_VIEN_START":
        case "QUYET_DINH_HOC_VU_REMOVE_SINH_VIEN_START":
            return { ...state, sinhVienStatus: eReducerStatusBase.is_saving };
        case "QUYET_DINH_HOC_VU_DONG_BO_KET_QUA_SUCCESS":
        case "QUYET_DINH_HOC_VU_ADD_SINH_VIEN_SUCCESS":
        case "QUYET_DINH_HOC_VU_REMOVE_SINH_VIEN_SUCCESS":
            return { ...state, sinhVienStatus: eReducerStatusBase.is_completed };
        case "QUYET_DINH_HOC_VU_DONG_BO_KET_QUA_ERROR":
        case "QUYET_DINH_HOC_VU_ADD_SINH_VIEN_ERROR":
        case "QUYET_DINH_HOC_VU_REMOVE_SINH_VIEN_ERROR":
            return { ...state, sinhVienStatus: eReducerStatusBase.is_completed };

        default:
            return state;
    }
}
